import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { buildPasswordChecks } from './passwordRules';
import styles from './PasswordStrength.module.scss';

const strengthLabels = [
  { key: 'weak', defaultValue: 'Weak' },
  { key: 'weak', defaultValue: 'Weak' },
  { key: 'fair', defaultValue: 'Fair' },
  { key: 'almost', defaultValue: 'Almost There' },
  { key: 'strong', defaultValue: 'Strong' },
];

type PasswordStrengthProps = {
  password: string;
  className?: string;
};

// The meter only appears once the user starts typing; the checklist is always visible so
// the rules are known before the first keystroke.
const PasswordStrength = ({ password, className }: PasswordStrengthProps) => {
  const { t } = useTranslation();

  const checks = buildPasswordChecks(password);
  const score = checks.filter((c) => c.met).length;
  const strengthLabel = strengthLabels[score];

  return (
    <div className={clsx(styles.root, className)}>
      {!!password && (
        <div className={styles.strength}>
          <div className={clsx(styles.strengthBars, score > 0 && styles[`score${score}`])}>
            {checks.map((c, i) => (
              <span
                key={c.key}
                className={clsx(styles.strengthSeg, i < score && styles.strengthSegOn)}
              />
            ))}
          </div>
          <p className={clsx(styles.strengthLabel, score > 0 && styles[`score${score}`])}>
            {t(`authPage.signup.password.strength.${strengthLabel.key}`, {
              defaultValue: strengthLabel.defaultValue,
            })}
          </p>
        </div>
      )}

      <div className={styles.reqList}>
        {checks.map((c) => (
          <div key={c.key} className={styles.reqRow}>
            <span className={clsx(styles.reqIcon, c.met && styles.met)}>✓</span>
            <span className={clsx(styles.reqText, c.met && styles.met)}>
              {t(`authPage.signup.password.req.${c.key}`, { defaultValue: c.defaultValue })}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PasswordStrength;
